import type { IconProps } from '../types/IconProps.ts';
export const Brush: IconProps = {
    name: 'Brush',
    children: [
        `<path d="m2.25 21.32 2.5-6.67A1 1 0 0 1 5.7 14h12.62a1 1 0 0 1 .93.65l2.5 6.67a.5.5 0 0 1-.46.68H2.72a.5.5 0 0 1-.47-.68" />`,
        `<path d="M6 14a2 2 0 1 1 0-4h4M14 10h4a2 2 0 1 1 0 4M10 10V4a2 2 0 1 1 4 0v6M8 22l1-4M16 22l-1-4" />`,
    ]
};